import React, { FC } from 'react'

import styled from 'styled-components'

import SortingIcon from 'src/Assets/Svg/common/Sorting.svg?react'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const Text = styled.span`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  display: none;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    display: block;
  }
`
const SubText = styled.span`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    display: none;
  }
`

const Container = styled.button`
  position: relative;
  display: inline-flex;
  height: 48px;
  padding: 0px 16px;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
  border-radius: 40px;
  background-color: ${({ theme }) => theme.color.white};
  border: 1px solid transparent;
  cursor: pointer;
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    gap: 0px;
  }
  svg {
    fill: ${({ theme }) => theme.color.darkGrey};
    path {
      fill: ${({ theme }) => theme.color.darkGrey};
    }
  }
  &:hover:enabled {
    border-radius: 40px;
    border: 1px solid ${({ theme }) => theme.color.lightGrey};
    background-color: ${({ theme }) => theme.color.hoverWhite};
  }
  &:focus-visible {
    border-radius: 40px;
    border: 1px solid ${({ theme }) => theme.color.darkGreen};
    outline: none;
    background-color: ${({ theme }) => theme.color.hoverWhite};
  }
  &:active {
    border-radius: 40px;
    border: 1px solid ${({ theme }) => theme.color.mediumGrey};
    outline: none;
    background-color: ${({ theme }) => theme.color.white};
  }
  &[disabled] {
    background-color: ${({ theme }) => theme.color.white};
    color: ${({ theme }) => theme.color.lightGrey};
    cursor: not-allowed;
    svg {
      fill: ${({ theme }) => theme.color.lightGrey};
    }
    ${Text} {
      color: ${({ theme }) => theme.color.lightGrey};
    }
    ${SubText} {
      color: ${({ theme }) => theme.color.lightGrey};
    }
  }
  &.ant-popover-open {
    border-color: ${({ theme }) => theme.color.lightGrey};
    &:hover {
      border: 1px solid transparent;
      box-shadow: none;
      border: 1px solid ${({ theme }) => theme.color.lightGrey};
    }
  }
`

interface SortingButtonProps extends React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> {
  text?: string
}

export const SortingButton: FC<SortingButtonProps> = ({
  text,
  ...restProps
}) => (
  <Container {...restProps}>
    <SortingIcon />
    <TextContainer>
      <Text>Sort by</Text>
      <SubText>{text}</SubText>
    </TextContainer>
  </Container>
)
